// 生产

let url = location.origin + "/";

module.exports = {
  upload: "https://b.mofangx.com/base",
  auth: url + "auth",
  pro: url + "pro",
  user: url + "user",
  order: url + "order",
  trainProduct: url + "trainProduct",
};

// 生产
// let url = "https://yun.mofangx.com/"

// module.exports = {
//     upload: "https://b.mofangx.com/base",
//     pay: url + "cloudpay",
//     pro: url + "pro",
//     user: url + "user",
//     order: url + "order",
// };



//////////////////
// WEBPACK FOOTER
// ./static/js/api/prod.js
// module id = UelF
// module chunks = 28